import {Component, computed, inject, input} from '@angular/core';

import connectClearRefinements, {
  ClearRefinementsConnectorParams,
  ClearRefinementsWidgetDescription
} from '../../../../../../../core/instantsearch-connectors/connectClearRefinements';
import {InstantSearchComponent} from '@core/instantsearch/components/instantsearch.component';
import {TypedBaseWidgetComponent} from '@core/instantsearch/types-based-widget';
import {TrackEventService} from '@core/services/track-event.service';

@Component({
  selector: 'app-clear-refinements',
  templateUrl: './clear-refinements.component.html',
  styleUrls: ['./clear-refinements.component.scss'],
  imports: []
})
export class ClearRefinementsComponent extends TypedBaseWidgetComponent<
  ClearRefinementsWidgetDescription,
  ClearRefinementsConnectorParams> {
  instantSearchInstance = inject(InstantSearchComponent);
  private trackEventService = inject(TrackEventService);


  public readonly resetLabel = input<string>('Clear refinements');
  public readonly includedAttributes = input<ClearRefinementsConnectorParams['includedAttributes']>();

  isHidden = computed(() => !this.state()?.canRefine);

  constructor() {
    super('ClearRefinements');
  }

  public override ngOnInit() {
    this.createWidget(
      connectClearRefinements,
      {
        includedAttributes: this.includedAttributes(),
      },
      {
        $$widgetType: 'ais.clearRefinements',
      }
    );

    super.ngOnInit();
  }

  public handleClick($event: MouseEvent) {
    $event.preventDefault();
    const state = this.state();
    if (state?.canRefine) {
      state.refine();
      this.trackEventService.trackClickEvent('clear-refinements');
    }
  }
}
